<template>
  <div>
    <ProductStatusInput
      v-model="innerValue" />
  </div>
</template>
<script>
import ProductStatusInput from '@components/input/ProductStatusInput';
import { mapMutations } from 'vuex';

export default {
  name: 'ProductStatusFilter',
  components: {
    ProductStatusInput
  },
  props: {
    value: {
      type: Number,
      required: true
    },
    field: {
      type: String,
      required: true
    }
  },
  computed: {
    innerValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
        this.setFilter({ key: this.field, value: val });
        if (val !== 0) {
          this.$emit('filter', () => (x) => x.status === val || val === 0);
        } else {
          this.$emit('filter', () => () => true);
        }
      }
    }
  },
  methods: {
    ...mapMutations({
      setFilter: 'dataTableFilters/setFilter'
    })
  },
  mounted() {
    this.innerValue = this.$store.state.dataTableFilters.filters[this.field] || this.value;
  }
};
</script>
<style>

</style>
